export const NOT_AVAILABLE = 'N/A';

export const formatValue = (value) => {
    if (value === null || value === undefined || value === '') return NOT_AVAILABLE;
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return value;
};

export const formattedCell = ({getValue}) => formatValue(getValue());
